import { Tabs as TabsPrimitive } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const TabsList = React.forwardRef(({ className, ...props }, ref) => {
    return (React.createElement(TabsPrimitive.List, { ref: ref, className: cn("in-tabs__list", className), ...props }));
});
TabsList.displayName = "TabsList";
export { TabsList };
//# sourceMappingURL=tabsList.js.map